var _circle, _circle2, _rect, _circle3, _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountSuspended = function SvgAccountSuspended(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Account_Suspended_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Account_Suspended_svg__a)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 50,
    y: -4,
    width: 45,
    height: 49,
    rx: 2,
    fill: "#000"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 5.5,
    cy: 63.5,
    r: 19.5,
    stroke: "#000",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.752 44.722c8.17 0 14.792-6.653 14.792-14.86C56.544 21.653 49.922 15 41.753 15c-8.17 0-14.792 6.654-14.792 14.861 0 8.208 6.622 14.861 14.791 14.861Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.752 42.722c8.17 0 14.792-6.653 14.792-14.86C54.544 19.653 47.922 13 39.753 13c-8.17 0-14.792 6.654-14.792 14.861 0 8.208 6.622 14.861 14.791 14.861Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M41.362 51.124a27.703 27.703 0 0 0-17.547 9.43 28.192 28.192 0 0 0-6.811 18.849v71.514c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.363 2.66 8.959 8.959 0 0 0 6.364-2.66 9.128 9.128 0 0 0 2.635-6.423v-9.083c0-2.409.949-4.719 2.636-6.423a8.959 8.959 0 0 1 6.364-2.66 8.96 8.96 0 0 1 6.363 2.66 9.128 9.128 0 0 1 2.636 6.423v9.083c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.364 2.66 8.959 8.959 0 0 0 6.363-2.66A9.128 9.128 0 0 0 71 150.917V78.252a27.525 27.525 0 0 0-2.331-11.032 27.3 27.3 0 0 0-6.55-9.14 27.002 27.002 0 0 0-9.651-5.689 26.823 26.823 0 0 0-11.106-1.267Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.362 47.124a27.703 27.703 0 0 0-17.547 9.43 28.192 28.192 0 0 0-6.811 18.849v71.514c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.363 2.66 8.959 8.959 0 0 0 6.364-2.66 9.128 9.128 0 0 0 2.635-6.423v-9.083c0-2.409.949-4.719 2.636-6.423a8.959 8.959 0 0 1 6.364-2.66 8.96 8.96 0 0 1 6.363 2.66 9.128 9.128 0 0 1 2.636 6.423v9.083c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.364 2.66 8.959 8.959 0 0 0 6.363-2.66A9.128 9.128 0 0 0 67 146.917V74.252a27.525 27.525 0 0 0-2.331-11.032 27.3 27.3 0 0 0-6.55-9.14 27.002 27.002 0 0 0-9.651-5.689 26.823 26.823 0 0 0-11.106-1.267Z",
    fill: "#EDE3D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Account_Suspended_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 47,
    width: 54,
    height: 109
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.362 47.124a27.703 27.703 0 0 0-17.547 9.43 28.192 28.192 0 0 0-6.811 18.849v71.514c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.363 2.66 8.959 8.959 0 0 0 6.364-2.66 9.128 9.128 0 0 0 2.635-6.423v-9.083c0-2.409.949-4.719 2.636-6.423a8.959 8.959 0 0 1 6.364-2.66 8.96 8.96 0 0 1 6.363 2.66 9.128 9.128 0 0 1 2.636 6.423v9.083c0 2.409.948 4.719 2.636 6.423a8.959 8.959 0 0 0 6.364 2.66 8.959 8.959 0 0 0 6.363-2.66A9.128 9.128 0 0 0 67 146.917V74.252a27.525 27.525 0 0 0-2.331-11.032 27.3 27.3 0 0 0-6.55-9.14 27.002 27.002 0 0 0-9.651-5.689 26.823 26.823 0 0 0-11.106-1.267Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Account_Suspended_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 46.49a18.28 18.28 0 0 0 6.473 6.246A17.264 17.264 0 0 0 40 55c2.977 0 5.908-.778 8.527-2.264A18.28 18.28 0 0 0 55 46.49a21.352 21.352 0 0 0-7.901-5.194 20.536 20.536 0 0 0-9.255-1.19c-4.865.476-9.413 2.736-12.844 6.384Z",
    fill: "#000"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#Account_Suspended_svg__c)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.239 68.258H45.022V47.107a15.108 15.108 0 0 1 30.217 0v21.151Zm-24.174-6.041h18.13v-15.11a9.064 9.064 0 1 0-18.129 0l-.001 15.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M75.239 51.083c0-.424-.266-.814-.684-.888a4.343 4.343 0 0 0-.706-.066h-3.654a1 1 0 0 0-1 1v10.088a1 1 0 0 1-1 1h-16.13a1 1 0 0 1-1-1V51.129a1 1 0 0 0-1-1h-3.654a4.318 4.318 0 0 0-.707.066c-.417.074-.683.463-.683.887v16.176a1 1 0 0 0 1 1h28.217a1 1 0 0 0 1-1V51.083Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.07 53.15H44.19c-1.21 0-2.19.981-2.19 2.19v22.816c0 1.21.98 2.19 2.19 2.19h31.88c1.21 0 2.19-.98 2.19-2.19V55.34c0-1.21-.98-2.19-2.19-2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.481 66.566a4.35 4.35 0 1 0-7.73 2.722c.323.42.492.938.478 1.468v.646a2.9 2.9 0 1 0 5.8 0v-.648a2.389 2.389 0 0 1 .5-1.5c.615-.761.951-1.71.952-2.688Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Account_Suspended_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.239 68.258H47.022V47.107a15.108 15.108 0 0 1 30.217 0v21.151Zm-24.174-6.041h18.13v-15.11a9.064 9.064 0 1 0-18.129 0l-.001 15.11Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.239 51.083c0-.424-.266-.814-.684-.888a4.343 4.343 0 0 0-.706-.066h-3.654a1 1 0 0 0-1 1v10.088a1 1 0 0 1-1 1h-16.13a1 1 0 0 1-1-1V51.129a1 1 0 0 0-1-1h-3.654a4.318 4.318 0 0 0-.707.066c-.417.074-.683.463-.683.887v16.176a1 1 0 0 0 1 1h28.217a1 1 0 0 0 1-1V51.083Z",
    fill: "#A79378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.07 53.15H46.19c-1.21 0-2.19.981-2.19 2.19v22.816c0 1.21.98 2.19 2.19 2.19h31.88c1.21 0 2.19-.98 2.19-2.19V55.34c0-1.21-.98-2.19-2.19-2.19Z",
    fill: "#A79378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.481 66.566a4.35 4.35 0 1 0-7.73 2.722c.323.42.492.938.478 1.468v.646a2.9 2.9 0 1 0 5.8 0v-.648a2.389 2.389 0 0 1 .5-1.5c.615-.761.951-1.71.952-2.688Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Account_Suspended_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(42 32)",
    d: "M0 0h36.26v48.346H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Account_Suspended_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(44 32)",
    d: "M0 0h36.26v48.346H0z"
  })))));
};
export default SvgAccountSuspended;